<script>
import { list } from '@/api/modalidade'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ modalidade: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="modalidade"
    width="1000"
    component="app-modalidade-grid"
    label="Modalidade"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
